import { useState } from "react";

const ReadMoreHtml = ({ html, limit = 300 }) => {
  const [expanded, setExpanded] = useState(false);

  return (
    <div className="event-description-wrapper">
      <div
        className={`event-description ${expanded ? "expanded" : "collapsed"}`}
        dangerouslySetInnerHTML={{ __html: html }}
      />
      <hr/>
      <div className="d-flex justify-content-center mt-2">
        <button
          className="read-more-btn"
          onClick={() => setExpanded(!expanded)}
        >
          {expanded ? "Read Less" : "Read More"}
        </button>
      </div> 
    </div>
  );
};

export default ReadMoreHtml;
